/* projects/wtaf/src/app/features/widgets/app-kpi-dashboard-widget/app-kpi-dashboard-widget.component.css */
.app-kpi-widget {
  width: 100%;
}
.widget-subtitle {
  font-size: 12px;
  color: #6c757d;
}
.view-toggle .btn {
  min-width: 88px;
}
.filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 4px;
}
.summary-strip {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.summary-badge {
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
}
.summary-total {
  background: #e8f2ff;
  color: #0f4fa8;
}
.summary-pass {
  background: #e9f8f0;
  color: #1a7f45;
}
.summary-fail {
  background: #fdeceb;
  color: #b42318;
}
.summary-unknown {
  background: #f3f4f6;
  color: #374151;
}
.summary-updated {
  margin-left: auto;
  font-size: 12px;
  color: #6b7280;
}
.trend-note {
  display: flex;
  align-items: flex-end;
  font-size: 12px;
  color: #6b7280;
}
.trend-note-inline {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.trend-inline-value {
  font-size: 12px;
  line-height: 31px;
  color: #6b7280;
  font-weight: 600;
}
.loading-msg,
.no-record,
.error-msg {
  font-size: 13px;
  font-weight: 500;
  padding: 10px 0;
}
.error-msg {
  color: #db3b21;
}
.loading-msg {
  color: #0f4fa8;
}
.no-record {
  color: #4b5563;
}
.kpi-card {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  background:
    linear-gradient(
      180deg,
      #ffffff 0%,
      #f8fafc 100%);
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
  padding: 10px;
  height: 100%;
}
.kpi-title {
  font-size: 12px;
  font-weight: 700;
  color: #1f2937;
  min-height: 36px;
  margin-bottom: 8px;
}
.kpi-gauge {
  --gauge-color: #1aaa55;
  width: 140px;
  height: 96px;
  position: relative;
  margin: 0 auto 10px auto;
}
.kpi-gauge-svg {
  width: 100%;
  height: 100%;
  display: block;
}
.kpi-gauge-track,
.kpi-gauge-progress {
  fill: none;
  stroke-width: 12;
  stroke-linecap: round;
}
.kpi-gauge-track {
  stroke: #e9ecef;
}
.kpi-gauge-progress {
  stroke: var(--gauge-color);
}
.kpi-gauge-marker {
  stroke: #ffffff;
  stroke-width: 1.5;
}
.kpi-gauge-label {
  font-size: 8px;
  fill: #6b7280;
}
.kpi-gauge-label-min {
  text-anchor: start;
}
.kpi-gauge-label-max {
  text-anchor: end;
}
.kpi-gauge-inner {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  background: transparent;
  margin-top: -90px;
  pointer-events: none;
}
.kpi-score {
  font-size: 14px;
  line-height: 1.1;
  font-weight: 700;
  color: #111827;
}
.kpi-status {
  font-size: 10px;
  font-weight: 700;
  margin-top: 1px;
}
.kpi-value-inside {
  font-size: 9px;
  color: #4b5563;
  margin-top: 2px;
  max-width: 110px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.status-pass {
  color: #15803d;
}
.status-fail {
  color: #b42318;
}
.status-unknown {
  color: #4b5563;
}
.kpi-meta-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
  color: #475467;
  border-top: 1px dashed #e5e7eb;
  padding-top: 5px;
  margin-top: 5px;
}
.trend-container {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  background: #ffffff;
}
.trend-table th,
.trend-table td {
  font-size: 11px;
  vertical-align: middle;
}
@media (max-width: 767px) {
  .summary-updated {
    margin-left: 0;
    width: 100%;
  }
  .trend-note {
    margin-top: 6px;
  }
}
/*# sourceMappingURL=app-kpi-dashboard-widget.component.css.map */
